import { useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ErrorBoundaryWrapper } from "@/components/ErrorBoundary";
import SimpleProjectDashboard from "@/components/SimpleProjectDashboard";
import { Button } from "@/components/ui/button";

const QuoteBuilder = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const quoteIdParam = searchParams.get("quoteId");

  // Validate quoteId if provided
  const quoteId = useMemo(() => {
    if (!quoteIdParam) return null;

    const parsed = Number.parseInt(quoteIdParam, 10);
    if (Number.isNaN(parsed) || parsed <= 0) {
      console.error(`Invalid quoteId parameter: ${quoteIdParam}`);
      return null;
    }

    return quoteIdParam; // Return as string for API consistency
  }, [quoteIdParam]);

  const handleBack = () => {
    navigate(-1);
  };

  if (!projectId) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Invalid Project</h1>
          <p className="text-muted-foreground mb-4">No project ID provided</p>
          <Button onClick={handleBack}>Go Back</Button>
        </div>
      </div>
    );
  }

  // Show error if quoteId is invalid but was provided in URL
  if (quoteIdParam && !quoteId) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <h1 className="text-2xl font-bold mb-4">Invalid Quote ID</h1>
          <p className="text-muted-foreground mb-4">
            The quote ID in the URL is invalid: "{quoteIdParam}"
          </p>
          <div className="flex gap-3 justify-center">
            <Button variant="outline" onClick={handleBack}>
              Go Back
            </Button>
            <Button onClick={() => navigate(`/quote-builder/${projectId}`)}>Start New Quote</Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundaryWrapper>
      <SimpleProjectDashboard projectId={projectId} quoteId={quoteId} onBack={handleBack} />
    </ErrorBoundaryWrapper>
  );
};

export default QuoteBuilder;
